<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active.sync="isFetchingSavedInfo"
      :can-cancel="false"
    ></b-loading>
    <div class="level">
      <div class="level-left">
        <h4 class="title is-4">{{ createOrUpdate }}</h4>
      </div>
      <div class="level-right">
        <button :class="buttonSave" @click="saveAndSend(false)">Save</button>
        &nbsp;
        <router-link
          :to="{ name: 'List of Sales Quote', params: { pageSize: 10 } }"
          class="button is-small"
          >View list</router-link
        >&nbsp;
        <button class="button is-small" @click="goBack">Go back</button>
      </div>
    </div>
    <hr />
    <div class="columns">
      <div class="column is-6">
        <div class="field">
          <label class="label is-small">Product name</label>
          <div class="control">
            <textarea
              type="text"
              class="input is-small"
              v-model="salesQuoteForTable.productName"
              placeholder="Enter product name"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label is-small">Description</label>
          <div class="control">
            <vue-editor
              v-model="salesQuoteForTable.description"
              :editorToolbar="customToolbar"
            ></vue-editor>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Quantity</label>
          <div class="control">
            <input
              type="number"
              class="input is-small"
              @keyup="calculateTotalKeyup"
              v-model="salesQuoteForTable.quantity"
            />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Uom</label>
          <div class="select is-small">
            <select v-model="salesQuoteForTable.unitOfMeasurement">
              <option value="0">box(es)</option>
              <option value="1">pc(s)</option>
              <option value="2">unit(s)</option>
              <option value="3">set(s)</option>
              <option value="4">ea</option>
              <option value="5">lic</option>
              <option value="6">lot</option>
            </select>
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Unit price</label>
          <div class="control">
            <input
              type="number"
              class="input is-small"
              @keyup="calculateTotalKeyup"
              v-model="salesQuoteForTable.unitPrice"
              placeholder="0.00"
            />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Total</label>
          <div class="control">
            <input
              type="number"
              class="input is-small"
              v-model="salesQuoteForTable.total"
              disabled
              placeholder="0.00"
            />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">&nbsp;</label>
          <div class="control">
            <button
              class="button is-small is-info"
              @click="addOrEditToSalesQuoteDetail"
            >
              {{ addOrEditToTable }}
            </button>
            &nbsp;
            <button
              class="button is-small"
              v-if="addOrEditToTable === 'Update'"
              @click="cancelSelectedSalesQuoteDetail"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
    <b-table :data="salesQuote.salesQuoteDetails" :loading="isLoadingTable">
      <template slot-scope="item">
        <b-table-column class="table-column-content-is-small" label="Quantity">
          {{ item.row.quantity }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Uom">
          <p v-show="item.row.unitOfMeasurement == 0">box(es)</p>
          <p v-show="item.row.unitOfMeasurement == 1">pc(s)</p>
          <p v-show="item.row.unitOfMeasurement == 2">unit(s)</p>
          <p v-show="item.row.unitOfMeasurement == 3">set(s)</p>
          <p v-show="item.row.unitOfMeasurement == 4">ea</p>
          <p v-show="item.row.unitOfMeasurement == 5">lic</p>
          <p v-show="item.row.unitOfMeasurement == 6">lot</p>
        </b-table-column>
        <b-table-column
          class="table-column-content-is-small"
          label="Product Name"
        >
          {{ item.row.productName }}
        </b-table-column>
        <b-table-column
          class="table-column-content-is-small"
          label="Description"
        >
          <div v-html="item.row.description"></div>
        </b-table-column>
        <b-table-column
          class="table-column-content-is-small"
          label="Unit Price"
        >
          {{ item.row.unitPrice | formatNumber }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label="Total">
          {{ item.row.total }}
        </b-table-column>
        <b-table-column class="table-column-content-is-small" label=" ">
          <button
            class="button is-warning is-small"
            @click="selectForEdit(item.row)"
          >
            Edit
          </button>
          &nbsp;
          <button
            :class="buttonDelete"
            @click="
              removeFromTable(
                item.row.salesQuoteDetailId
                  ? item.row.salesQuoteDetailId
                  : item.row.tempId
              )
            "
          >
            Delete
          </button>
        </b-table-column>
      </template>
    </b-table>
    <div style="clear: both" />
    <hr />
    <div class="columns">
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Quotation #</label>
          <div class="control">
            <input
              type="text"
              class="input is-small"
              value="AUTO GENERATED"
              v-model="salesQuote.quatationNumber"
              disabled
            />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Agent</label>
          <div class="control">
            <input
              type="text"
              class="input is-small"
              v-model="agentName"
              readonly
            />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Clients</label>
          <div class="control">
            <b-autocomplete
              v-model="clientName"
              size="is-small"
              :data="clients"
              placeholder="Search clients"
              @select="(option) => (selectedClient = option)"
              @input="searchClients"
              v-validate="'required'"
              name="Client"
              :loading="isFetchingClients"
            >
              <template slot="empty">
                <span v-if="isFetchingClients"> Please wait... </span>
                <span v-if="clients.length === 0"> No results found </span>
              </template>
            </b-autocomplete>
            <span style="font-size: 12px" class="has-text-danger">{{
              errors.first("Client")
            }}</span>
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Quotation date</label>
          <div class="control">
            <input
              type="date"
              class="input is-small"
              v-model="salesQuote.quatationDate"
            />
          </div>
        </div>
      </div>
    </div>
    <div style="clear: both"></div>
    <div class="columns">
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Validity</label>
          <div class="control">
            <textarea
              type="date"
              class="input is-small"
              v-model="salesQuote.validity"
              style="height: 50px"
            />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Services</label>
          <div class="control">
            <textarea
              type="date"
              class="input is-small"
              v-model="salesQuote.services"
              style="height: 50px"
            />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Delivery</label>
          <div class="control">
            <textarea
              type="date"
              class="input is-small"
              v-model="salesQuote.delivery"
              style="height: 50px"
            />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Terms</label>
          <div class="control">
            <input
              type="text"
              class="input is-small"
              v-model="clientTerm"
              style="height: 50px"
            />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Warranty</label>
          <div class="control">
            <textarea
              type="date"
              class="input is-small"
              v-model="salesQuote.warranty"
              style="height: 50px"
            />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Note</label>
          <div class="control">
            <textarea
              type="date"
              class="input is-small"
              v-model="salesQuote.note"
              style="height: 50px"
            />
          </div>
        </div>
      </div>
    </div>

    <h5 class="title is-5">Total</h5>
    <div class="notification">
      <loading
        :active.sync="isLoadingTotal"
        color="#3BAFDA"
        :can-cancel="false"
        :is-full-page="isFullPage"
      ></loading>
      <div class="level">
        <div class="level-left"></div>
        <div class="level-right">
          <div class="field">
            <label class="label is-small">Amount</label>
            <div class="control">
              <h4 class="title is-4">
                {{ salesQuote.totalAmount | formatNumber }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="level">
      <div class="level-left"></div>
      <div class="level-right">
        <button :class="buttonSave" @click="saveAndSend(false)">Save</button>
        &nbsp;
        <router-link
          :to="{ name: 'List of Sales Quote', params: { pageSize: 10 } }"
          class="button is-small"
          >View list</router-link
        >&nbsp;
        <button class="button is-small" @click="goBack">Go back</button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import _ from "lodash";
import axios from "axios";
import AppToast from "../frontend/appToast";
import AppButton from "../frontend/appButton";
import Loading from "vue-loading-overlay";
import moment from "moment";
import VueJWT from "vuejs-jwt";
import { VueEditor } from "vue2-editor";
import AuthService from "../../_services/auth";
import numeral from "numeral";

Vue.use(VueJWT);
Vue.filter("formatNumber", function (value) {
  return numeral(value).format("0,0.00"); // displaying other groupings/separators is possible, look at the docs
});

Vue.use(VueJWT);

const appToast = new AppToast();
const appButton = new AppButton();
const authService = new AuthService();

export default {
  components: {
    Loading,
    VueEditor,
  },
  data: () => ({
    customToolbar: [["bold", "italic", "underline"], ["image"]],
    createOrUpdate: "Create",
    salesQuote: {
      salesQuoteId: 0,
      totalAmount: 0.0,
      quatationDate: null,
      services: "",
      warranty: "",
      note: "",
      validity: "Prices are subject to change without prior notice",
      services: "Free Delivery within Metro Manila",
      delivery: "3-5 working days if On Stock",
      warranty: "1 Year hardware warranty",
      salesQuoteDetails: [],
    },
    salesQuoteForTable: {
      quantity: 1,
      unitOfMeasurement: 0,
      unitPrice: 0,
      total: 0,
    },
    addOrEditToTable: "Add",
    agentName: "",
    agentId: 0,
    // loadings
    isLoadingTable: false,
    isLoadingTotal: false,
    isFetchingSavedInfo: false,
    isFullPage: false,
    // buttons
    buttonDelete: appButton.isLoadingDanger(false),
    buttonSave: appButton.isLoadingSuccess(false),
    buttonSaveAndSend: appButton.isLoadingSuccess(false),
    // search clients
    clientName: "",
    clients: [],
    selectedClient: 0,
    isFetchingClients: false,
    clientTerm: "",
  }),
  created() {
    const salesQuoteId = this.$route.params.salesQuoteId;

    var decodedToken = Vue.$jwt.decode(localStorage.getItem("token"));
    this.agentId = decodedToken.nameid;

    if (salesQuoteId) {
      // Edit mode
      this.createOrUpdate = "...";
      this.getById(salesQuoteId);
    } else {
      // Create mode
      this.getCurrentDateFromServer();

      this.agentName = decodedToken.unique_name;
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getCurrentDateFromServer() {
      this.isFetchingSavedInfo = true;
      axios
        .get(`api/settings/current-date`)
        .then((response) => {
          this.salesQuote.quatationDate = moment(response.data).format(
            "YYYY-MM-DD"
          );
        })
        .catch((error) => console.log(error))
        .then(() => {
          this.isFetchingSavedInfo = false;
        });
    },
    getById(salesQuoteId) {
      this.isFetchingSavedInfo = true;
      axios
        .get(`api/salesquotes/${salesQuoteId}`)
        .then((response) => {
          this.salesQuote = response.data;
          this.clientTerm = this.salesQuote.terms;
          this.clientName = this.salesQuote.client;
          this.agentName = this.salesQuote.user;
          this.salesQuote.quatationDate = moment(
            this.salesQuote.quatationDate
          ).format("YYYY-MM-DD");
        })
        .catch((error) =>
          appToast.danger(
            "Something went wrong. Failed fetching sales quote info"
          )
        )
        .then(() => {
          this.isFetchingSavedInfo = false;
          this.createOrUpdate = "Edit";
        });
    },
    calculateTotalAmount() {
      this.isLoadingTotal = true;
      axios
        .post(
          `api/salesquotes/calculate-total-amount`,
          this.salesQuote.salesQuoteDetails
        )
        .then((response) => {
          this.salesQuote.totalAmount = response.data;
        })
        .catch((error) =>
          appToast.danger(
            "Something went wrong. Failed to calculate total amount"
          )
        )
        .then(() => {
          this.isLoadingTotal = false;
        });
    },
    saveAndSend(isSend) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.salesQuote.totalAmount <= 0) {
            appToast.danger(
              "Can't save 0 value of total amount. Please add sales quote detail with valid unit price"
            );
            return false;
          }

          if (!this.salesQuote.quatationDate) {
            appToast.danger("Quotation date is empty. Choose valid date");
            return false;
          }

          this.buttonSave = appButton.isLoadingSuccess(true);

          const salesQuoteId = this.salesQuote.salesQuoteId;
          if (salesQuoteId == 0) {
            // Create
            this.salesQuote.terms = this.clientTerm;
            axios
              .post(`api/salesquotes/`, this.salesQuote)
              .then((response) => {
                appToast.success(response.data);
                this.$router.push({ name: "List of Sales Quote" });
              })
              .catch((error) => appToast.danger(error));
          } else {
            // Edit
            this.salesQuote.terms = this.clientTerm;
            axios
              .delete(
                `api/salesquotes/delete-sales-quote-detail-by-sales-quote-id/${salesQuoteId}`
              )
              .then((response) => {
                if (response.data) {
                  // if successfully deleted detail
                  axios
                    .post(
                      `api/salesquotes/create-sales-quote-detail/${salesQuoteId}`,
                      this.salesQuote.salesQuoteDetails
                    )
                    .then((response) => {
                      if (response.data) {
                        axios
                          .put(
                            `api/salesquotes/${salesQuoteId}`,
                            this.salesQuote
                          )
                          .then((response) => {
                            appToast.success(response.data);
                          })
                          .catch((error) =>
                            appToast.danger(
                              "Something went wrong. Failed to update"
                            )
                          );
                      } else {
                        appToast.danger(
                          "Something went wrong. Failed to update"
                        );
                      }
                    });
                } else {
                  appToast.danger("Something went wrong. Failed to update");
                }
              });
          }
          this.buttonSave = appButton.isLoadingSuccess(false);
        }
      });
    },
    searchClients() {
      //authService.isLoggedIn() // check login
      if (this.clientName) {
        axios
          .get(`api/searchqueries/clients-by-name/${this.clientName}/false`)
          .then((response) => {
            this.clients = response.data;
          })
          .catch((error) => {
            console.log(error.response.status);
          });
      }
    },
    addOrEditToSalesQuoteDetail() {
      if (this.salesQuoteForTable.quantity <= 0) {
        appToast.warning("Quantity must not be 0 or less than 0");
        return false;
      }

      if (!this.salesQuoteForTable.productName) {
        appToast.warning("Product name is empty");
        return false;
      }

      this.isLoadingTable = true;

      if (this.addOrEditToTable === "Update") {
        let index = null;

        let isUsingTempId = false;
        const idTypeOf = typeof this.salesQuoteForTable.id; // check if it temp id
        if (idTypeOf === "string") {
          index = _.findIndex(this.salesQuote.salesQuoteDetails, {
            tempId: this.salesQuoteForTable.id,
          });

          isUsingTempId = true;
        } else {
          index = _.findIndex(this.salesQuote.salesQuoteDetails, {
            salesQuoteDetailId: this.salesQuoteForTable.id,
          });
        }

        // if using tempid, supply the tempId property if not, supply the primary key
        if (isUsingTempId) {
          this.salesQuote.salesQuoteDetails.splice(index, 1, {
            quantity: this.salesQuoteForTable.quantity,
            unitOfMeasurement: this.salesQuoteForTable.unitOfMeasurement,
            productName: this.salesQuoteForTable.productName,
            description: this.salesQuoteForTable.description,
            unitPrice: this.salesQuoteForTable.unitPrice,
            total: this.salesQuoteForTable.total,
            tempId: this.salesQuoteForTable.id,
          });
        } else {
          this.salesQuote.salesQuoteDetails.splice(index, 1, {
            quantity: this.salesQuoteForTable.quantity,
            unitOfMeasurement: this.salesQuoteForTable.unitOfMeasurement,
            productName: this.salesQuoteForTable.productName,
            description: this.salesQuoteForTable.description,
            unitPrice: this.salesQuoteForTable.unitPrice,
            total: this.salesQuoteForTable.total,
            salesQuoteDetailId: this.salesQuoteForTable.id,
          });
        }
      } else {
        this.salesQuote.salesQuoteDetails = [
          ...this.salesQuote.salesQuoteDetails,
          {
            quantity: this.salesQuoteForTable.quantity,
            unitOfMeasurement: this.salesQuoteForTable.unitOfMeasurement,
            productName: this.salesQuoteForTable.productName,
            description: this.salesQuoteForTable.description,
            unitPrice: this.salesQuoteForTable.unitPrice,
            total: this.salesQuoteForTable.total,
            tempId: `t${new Date().getTime()}`,
          },
        ];
      }
      this.calculateTotalAmount();
      this.defaultForTable();
      this.isLoadingTable = false;
    },
    selectForEdit(row) {
      this.addOrEditToTable = "Update";
      this.salesQuoteForTable.quantity = row.quantity;
      this.salesQuoteForTable.unitOfMeasurement = row.unitOfMeasurement;
      this.salesQuoteForTable.productName = row.productName;
      this.salesQuoteForTable.description = row.description;
      this.salesQuoteForTable.unitPrice = row.unitPrice;
      this.salesQuoteForTable.total = row.total;

      // check if the id temporary or from saved item
      let tableId = 0;
      row.tempId ? (tableId = row.tempId) : (tableId = row.salesQuoteDetailId);

      this.salesQuoteForTable.id = tableId;
    },
    removeFromTable(id) {
      this.isLoadingTable = true;
      this.buttonDelete = appButton.isLoadingDanger(true);
      // check if id is temp or has t
      const idTypeOf = typeof id;
      // check if id is string, if it is string, remove from the array, if not, remove from the database
      if (idTypeOf === "string") {
        const hasT = id.charAt(0);
        if (hasT === "t") {
          _.remove(this.salesQuote.salesQuoteDetails, { tempId: id }); // Create module
        }
      } else {
        // delete if the id is from saved info
        _.remove(this.salesQuote.salesQuoteDetails, { salesQuoteDetailId: id });
      }
      this.isLoadingTable = false;
      this.buttonDelete = appButton.isLoadingDanger(false);
      this.calculateTotalAmount();
    },
    calculateTotalKeyup() {
      this.salesQuoteForTable.total =
        this.salesQuoteForTable.quantity * this.salesQuoteForTable.unitPrice;
    },
    defaultForTable() {
      this.salesQuoteForTable = {
        quantity: 1,
        unitOfMeasurement: 0,
        productName: "",
        unitPrice: 0,
        total: 0,
      };
      this.addOrEditToTable = "Add";
    },
    cancelSelectedSalesQuoteDetail() {
      this.defaultForTable();
    },
  },
  watch: {
    selectedClient() {
      if (this.selectedClient) {
        this.salesQuote.clientId = this.selectedClient.id;
        this.clientTerm = this.selectedClient.description1;
      } else {
        this.selectedClient = 0;
        this.clientTerm = "";
      }
    },
  },
};
</script>
